import * as filterSelectors from '../selectors';
import * as types from '../types';
import {
    setTravelModeValue,
} from './travelModes';

function setCarrierActive(carrierCode, travelMode, isActive, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());

        dispatch(_setCarrierActive(filterId, carrierCode, travelMode, isActive));
        const carriersFilterData = filterSelectors.selectCarriersFilterData(
            getState(),
            filterId,
        );
        const travelModesFilterData = filterSelectors.selectTravelModesFilterData(
            getState(),
            filterId,
        );

        const oldState = travelModesFilterData[travelMode].state;
        const newState = _computeTravelModeState(travelMode, carriersFilterData);
        if (newState !== oldState) {
            return dispatch(setTravelModeValue(travelMode, newState, filterId));
        }
    };
}

function _setCarrierActive(filterId, carrierCode, travelMode, isActive) {
    return {
        meta: {
            filterId,
            travelMode,
            carrierCode,
        },
        payload: isActive,
        type: types.SET_CARRIER_ACTIVE,
    };
}

function _computeTravelModeState(travelMode, carrierMap) {
    if (_allCarriersActive(travelMode, carrierMap)) {
        return true;
    }

    if (_allCarriersInactive(travelMode, carrierMap)) {
        return false;
    }

    return 'mixed';
}

function _allCarriersActive(travelMode, carrierMap) {
    return Object.values(carrierMap)
        .filter((carrierObj) => carrierObj.hasOwnProperty(travelMode))
        .every((carrierObj) => carrierObj[travelMode].isActive);
}

function _allCarriersInactive(travelMode, carrierMap, carrierCodes) {
    return Object.values(carrierMap)
        .filter((carrierObj) => carrierObj.hasOwnProperty(travelMode))
        .every((carrierObj) => !carrierObj[travelMode].isActive);
}

function setCarrierOnlyActive(carrierCode, travelModeToSet, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());

        const travelModesFilterData = filterSelectors.selectTravelModesFilterData(
            getState(),
            filterId,
        );

        Object.keys(travelModesFilterData).forEach((travelMode) => {
            dispatch(setTravelModeValue(travelMode, false, filterId));
            if (travelModeToSet === travelMode) {
                dispatch(setTravelModeValue(travelMode, 'mixed', filterId));
            }
        });

        dispatch(_setCarrierActive(filterId, carrierCode, travelModeToSet, true));
    };
}

function setCarriersActive(carrierCodes, travelMode, isActive, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        dispatch(_setCarriersActive(filterId, carrierCodes, travelMode, isActive));
    };
}

function _setCarriersActive(filterId, carrierCodes, travelMode, isActive) {
    return {
        meta: {
            filterId,
            carrierCodes,
            travelMode,
        },
        payload: isActive,
        type: types.SET_CARRIERS_ACTIVE,
    };
}

function resetCarriers(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        return dispatch(_resetCarriers(filterId));
    };
}

function _resetCarriers(filterId) {
    return {
        meta: filterId,
        type: types.RESET_CARRIERS,
    };
}

export {
    resetCarriers,
    setCarrierActive,
    setCarrierOnlyActive,
    setCarriersActive,
};
